import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {TokenService} from '../services/token.service';
import {RouteUrls} from '../constants/RouteUrls';

/**
 * Auth guards is used to guards urls from guest users
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private tokenService: TokenService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.tokenService.isAuthenticated() && !this.tokenService.isTokenExpired()) {
      return true;
    } else if (this.tokenService.isAuthenticated() && this.tokenService.isTokenExpired()) {
      this.router.navigate([`/${RouteUrls.REDIRECT}`], {queryParams: {refreshToken: true, redirectTo: state.url}});
      return false;
    } else {
      this.router.navigate(['/' + RouteUrls.LOGOUT],
        {queryParams: {redirectTo: state.url}});
      return false;
    }
  }
}
